import { ErrorHandler, makeEnvironmentProviders } from '@angular/core';
import { GlobalErrorHandler } from '../logging/global-error-handler';
import { ApplicationInsightService } from '../services/application-insights.service';
import { APPLICATION_INSIGHTS_INSTRUMENTATION_TOKEN } from '../tokens/application-insights-intrumentation-key.token';

export interface ApplicationInsightsProviderConfig {
  instrumentationKey: string;
}

export const provideApplicationInsights = ({ instrumentationKey }: ApplicationInsightsProviderConfig) =>
  makeEnvironmentProviders([
    { provide: APPLICATION_INSIGHTS_INSTRUMENTATION_TOKEN, useValue: instrumentationKey },
    { provide: ApplicationInsightService },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
  ]);
